var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "scannerEnabled", color: "primary", label: "" },
                model: {
                  value: _vm.scannerEnabled,
                  callback: function ($$v) {
                    _vm.scannerEnabled = $$v
                  },
                  expression: "scannerEnabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.analyzer_vulndb_enable")) + "\n    "),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "vulndb-consumer-key",
              label: _vm.$t("admin.consumer_key"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "email",
              lazy: "true",
            },
            model: {
              value: _vm.consumerKey,
              callback: function ($$v) {
                _vm.consumerKey = $$v
              },
              expression: "consumerKey",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "vulndb-consumer-secret",
              label: _vm.$t("admin.consumer_secret"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "password",
              lazy: "true",
            },
            model: {
              value: _vm.consumerSecret,
              callback: function ($$v) {
                _vm.consumerSecret = $$v
              },
              expression: "consumerSecret",
            },
          }),
          _c("hr"),
          _vm._v(
            "\n    " + _vm._s(_vm.$t("admin.analyzer_vulndb_desc")) + "\n  "
          ),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }